<script lang="ts">
	import type { i18n } from 'types/common'

	import ScannerConfiguration, { type ScannerOptions } from '@isoftdata/svelte-scanner-configuration'
	import { setObject } from '@isoftdata/utility-storage'
	import { getContext } from 'svelte'

	interface Props {
		barcodeScannerOptions: ScannerOptions
	}

	let { barcodeScannerOptions }: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

<small
	>{translate(
		'configuration.scanner.noteThisConfigurationOnlyAffectsThisDevice.',
		'Note: This configuration only affects this device.',
	)}</small
>
<hr />
<ScannerConfiguration
	preamble={barcodeScannerOptions.preamble}
	postamble={barcodeScannerOptions.postamble}
	enableHoneywell={barcodeScannerOptions.enableHoneywell}
	keyboardWedgeEnabled={barcodeScannerOptions.keyboardWedgeEnabled}
	change={options => {
		setObject(localStorage, 'barcodeScannerOptions', options)
	}}
/>
